import { fetch } from '@/shared/fetch';
import { PatchPetWeightParams } from '@/features/booking/widgets/describe-problem/model/types';

export const patchPetWeight = async ({
    petWeightKg,
    petId,
}: PatchPetWeightParams) => {
    return await fetch(`/api/pets/${petId}/weight`, 'PATCH', petWeightKg);
};
